/** @public */
export type LeftPanelItemsProps = {
  children?: React.ReactNode;
};

/**
 * @public
 */
export const LeftPanelItems = (props: LeftPanelItemsProps) => {
  const { children } = props;

  return (
    <>
      <cds-left-panel-items>{children ? children : null}</cds-left-panel-items>
    </>
  );
};
